import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit
} from "@angular/core";
import { SvgIconRegistryService } from "angular-svg-icon";

@Component({
  selector: "app-ui-svg",
  templateUrl: "./ui-svg.component.html",
  styleUrls: ["./ui-svg.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiSvgComponent implements OnInit {
  private readonly _names = new Set();

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>,
    private readonly svgIconRegistryService: SvgIconRegistryService
  ) {}

  ngOnInit(): void {
    this._elementRef.nativeElement.childNodes.forEach((_) =>
      this.addSvgElement(_ as SVGElement)
    );
  }

  private addSvgElement(node: SVGElement) {
    const name = node.getAttribute("name");
    if (!name) {
      throw new Error("Svg 'name' attribute not found");
    }

    if (this._names.has(name)) {
      throw new Error(`Svg 'name' duplication: ${name}`);
    }

    this.svgIconRegistryService.addSvg(name, node.outerHTML);
    this._names.add(name);
  }
}
